import style from './style.module.less';

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Side = (props) => {
    const navigate = useNavigate();
    useEffect(() => {
        //      学习公社 展示默认图
        if (props.side?.side_name === '运营端' && !['100', '1704384780671352833'].includes(props.tenantInfo?.id) && props.userInfo?.adminInfo?.super_admin) {
            try {
                navigate('/operate/manage/statistics');
            } catch (e) {
                window.location.href = `https://${window.location.host}/operate/manage/statistics`;
            }
        }
    }, [props.userInfo?.adminInfo]);

    return <div className={style.header} />;
};

export default Side;
